import { memo, useState } from 'react'
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  useDisclosure,
} from '@chakra-ui/react'

import { Bell, BellRinging } from 'components/icons'
import { IconButtonWithBadge } from 'components'
import { useNotificationsManager } from 'contexts/NotificationsManager/Provider'
import markAllNotifiationsAsViewed from 'services/calls/notifications/markAllNotifiationsAsViewed'
import NotificationContent from './components/NotificationContent'

function NotificationButton() {
  const [loading, setLoading] = useState(false)

  const { isOpen, onClose, onOpen } = useDisclosure()

  const {
    loadingNotifications,
    notViewNotificationsCount,
    setNotViewNotificationsCount,
  } = useNotificationsManager()

  async function setMarkerAllNotificationsAsViewed() {
    setLoading(true)
    const response = await markAllNotifiationsAsViewed()

    if (response?.header?.success) {
      onOpen()
      setNotViewNotificationsCount(0)
    }
    setLoading(false)
  }

  return (
    <>
      <IconButtonWithBadge
        isLoading={loading || loadingNotifications}
        onClick={setMarkerAllNotificationsAsViewed}
        aria-label="Botão para abrir as suas notificações do sistema"
        variant="ghost"
        colorScheme="gray"
        icon={isOpen ? <BellRinging /> : <Bell />}
        amount={notViewNotificationsCount}
      />

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          <DrawerHeader>
            <Heading fontWeight="bold">Notificações</Heading>
          </DrawerHeader>

          <DrawerBody p={0}>
            <NotificationContent />
          </DrawerBody>

          <DrawerFooter>
            <Button
              minWidth="100%"
              variant="outline"
              size="md"
              onClick={onClose}
            >
              Fechar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default memo(NotificationButton)
